import PropTypes from 'prop-types'

const colors = {
  available: 'bg-available',
  unavailable: 'bg-unavailable',
  disabled: 'bg-disabled',
  guardian_booked: 'bg-gray-400',
  impersonating: 'bg-emerald-600',
  live: 'bg-blue-400',
  selected: 'bg-selected',
  booking: 'bg-booking',
  attended: 'bg-attended',
  absent: 'bg-absent',
  unknown: 'bg-unknown',
}

const Dot = ({ color, pulse = false, text = null }) => {
  const bgColor = colors[color.toLowerCase()] || "bg-gray-300"
  const pulseClass = pulse ? "animate-pulse" : ""

  return (
    <div className="flex items-center">
      <div className={`w-3 h-3 mr-2 rounded-full ${bgColor} ${pulseClass}`}></div> 
      { text && <span className='text-sm text-content2-foreground'>{text}</span> }
    </div>
  )
}

Dot.propTypes = {
  color: PropTypes.string,
  pulse: PropTypes.bool,
  text: PropTypes.string
}

export default Dot